<h2 mat-dialog-title>Request files from a hospital</h2>

<mat-dialog-content class="hospital-link-content">
  <p class="hint">
    Matter {{ data.patientCaseName }}. The hospital opens the link, confirms a code sent to the address below and uploads
    medical images or documents. The link works for the days you choose and closes when the hospital presses Finish.
  </p>

  <form class="link-form" (ngSubmit)="create()">
    <mat-form-field appearance="outline">
      <mat-label>Hospital name</mat-label>
      <input matInput name="hospitalName" maxlength="120" [(ngModel)]="hospitalName" autocomplete="off" />
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Recipient email</mat-label>
      <input matInput type="email" name="recipientEmail" maxlength="254" [(ngModel)]="recipientEmail" autocomplete="off" />
    </mat-form-field>

    <mat-form-field appearance="outline" class="ttl-field">
      <mat-label>Expires in</mat-label>
      <mat-select name="ttlDays" [(ngModel)]="ttlDays">
        <mat-option *ngFor="let d of ttlOptions" [value]="d">{{ d }} days</mat-option>
      </mat-select>
    </mat-form-field>

    <button mat-raised-button color="primary" type="submit" [disabled]="!canCreate">Create link</button>
  </form>

  <div *ngIf="newLinkUrl" class="new-link">
    <p><strong>Copy this link now and send it to the hospital yourself. It cannot be shown again.</strong></p>
    <div class="new-link-row">
      <input class="new-link-input" readonly [value]="newLinkUrl" (focus)="selectLinkText($event)" />
      <button mat-stroked-button type="button" (click)="copyLink()">Copy link</button>
    </div>
    <p class="hint">The hospital will receive a code at {{ newLinkRecipient }} when it opens the link.</p>
  </div>

  <h3 class="list-title">Links for this matter</h3>
  <div *ngIf="loading" class="hint">Loading&hellip;</div>
  <p *ngIf="!loading && links.length === 0" class="hint">No links yet.</p>

  <div *ngIf="links.length" class="table-wrap">
    <table class="links-table">
      <thead>
        <tr>
          <th>Hospital</th>
          <th>Recipient</th>
          <th>Created</th>
          <th>Expires</th>
          <th>Status</th>
          <th>Files</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let l of links">
          <td>{{ l.sourceLabel || '-' }}</td>
          <td>{{ l.recipientEmail || '-' }}</td>
          <td>{{ l.createdAtMs | date: 'short' }}</td>
          <td>{{ l.expiresAtMs | date: 'short' }}</td>
          <td>{{ l.status }}</td>
          <td>{{ l.fileCount }}</td>
          <td class="actions">
            <button *ngIf="l.status === 'active'" mat-button color="warn" type="button" (click)="revoke(l)">Revoke</button>
            <button *ngIf="l.imagingCaseId" mat-button type="button" (click)="openCase(l)">Open case</button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button type="button" (click)="close()">Close</button>
</mat-dialog-actions>
